import React, { useState } from "react";
import { useInView } from "react-intersection-observer"; // Import useInView
import CountUp from "react-countup"; // Import CountUp
import bg from "../../Assets/recent-bg.png";
import { GiPlainSquare } from "react-icons/gi";
import { MdArrowOutward } from "react-icons/md";
import { useNavigate } from "react-router-dom";
// import commercial from "../../Assets/builders-1.jpg";
import commercial1 from "../../Assets/Builders.webp";
import residential3 from "../../Assets/ourworks/1-kk-nagar-house-exterior-1-225x215.jpg";
import residential4 from "../../Assets/ourworks/FINAL-VIEW-KAMALUDEEN-225x215.jpg";
import residential5 from "../../Assets/ourworks/bangaloe-project-elevation-225x215.jpg";
import residential6 from "../../Assets/ourworks/hosur-project-225x215.jpg";

// Image Data
const imageData = {
  all: [
    { id: 1, src: residential3, category: "residential", title: "Residential Project 4", subtitle: "1-kk-nagar-house-exterior" },
    { id: 3, src: residential5, category: "residential", title: "Residential Project 6", subtitle: "bangalore-project-elevation" },
    { id: 4, src: residential6, category: "residential", title: "Residential Project 7", subtitle: "hosur-project" },
    { id: 5, src: commercial1, category: "commercial", title: "Commercial Project 2", subtitle: "Shopping Complex" },


 
  ], 
  commercial: [
    { id: 5, src: commercial1, category: "commercial", title: "Commercial Project 2", subtitle: "Shopping Complex" },

  ],
  residential: [
    { id: 1, src: residential3, category: "residential", title: "Residential Project 4", subtitle: "1-kk-nagar-house-exterior" },
    { id: 2, src: residential4, category: "residential", title: "Residential Project 5", subtitle: "finalView-Kamaludeen" },
    { id: 3, src: residential5, category: "residential", title: "Residential Project 6", subtitle: "bangalore-project-elevation" },
    { id: 4, src: residential6, category: "residential", title: "Residential Project 7", subtitle: "hosur-project" },
  ],
};

const Recent = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const navigate = useNavigate();

  // Intersection Observer to detect when the count section is in view
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once
    threshold: 0.3, // Trigger when 30% of the element is visible
  });

  return (
    <div className="max-w-screen-2xl mx-auto bg-[#121315] text-white py-10">
      <div className="relative">
        {/* Background Image */}
        <div className="flex justify-center">
          <img src={bg} alt="Recent Projects" className="w-[400px] md:w-[500px] md:h-auto h-[2100px] object-cover" />
        </div>

        {/* Content Section */}
        <div className="absolute w-full px-6 top-16 lg:px-20 mx-auto text-center lg:text-left">
          <div className="max-w-screen-lg mx-auto">
            {/* Title */}
            <div className="flex justify-center lg:justify-start space-x-2 mt-4">
              <GiPlainSquare className="text-[#068b07]" size={16} />
              <p className="text-gray-400 text-xs font-medium">OUR WORK</p>
              <GiPlainSquare className="text-[#068b07]" size={16} />
            </div>

            {/* Heading & Description */}
            <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start mt-4">
              <div className="lg:w-2/3 space-y-3">
                <h1 className="text-3xl md:text-4xl font-semibold">Explore Recent Projects</h1>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Bring to the table win-win survival strategies to ensure proactive domination.
                </p>
              </div>

              {/* Projects Completed */}
              <div className="mt-6 lg:mt-0" ref={ref}>
                {inView && (
                  <span className="text-[#184497] text-5xl md:text-7xl font-medium p-3">
                    <CountUp start={0} end={125} duration={2} suffix="+" />
                  </span>
                )}
                <h2 className="text-white text-md font-medium">COMPLETED PROJECTS</h2>
              </div>
            </div>

            {/* Category Buttons */}
            <div className="flex justify-center lg:justify-start space-x-6 mt-6">
              {["all", "commercial", "residential"].map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 text-sm font-medium ${
                    selectedCategory === category ? "bg-[#068b07] text-white" : "text-gray-300 hover:text-white"
                  } transition-all duration-300`}
                >
                  {category.toUpperCase()}
                </button>
              ))}
            </div>

            {/* Divider */}
            <div className="flex items-center pt-6">
              <GiPlainSquare className="text-[#068b07]" size={12} />
              <div className="w-full h-[1px] bg-gray-500 mx-2"></div>
              <GiPlainSquare className="text-[#068b07]" size={12} />
            </div>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 pt-6">
          {(imageData[selectedCategory] || []).map((image) => (

              <div key={image.id} className="relative group overflow-hidden">
                {/* Image */}
                <img
                  src={image.src}
                  alt={image.category}
                  className="w-full h-[350px] object-cover cursor-pointer transition-transform duration-300 group-hover:scale-105"
                />

                {/* Text Overlay */}
                <div className="absolute right-0 flex flex-col mx-auto bottom-7">
                  <h1 className="text-gray-300 p-2 bg-[#121315] opacity-85 w-40 py-2 text-xs font-medium">{image.title}</h1>
                  <h2 className="text-black p-2 bg-slate-100 font-bold capitalize py-4 w-[260px] text-md">{image.subtitle}</h2>
                </div>
              </div>
            ))}
          </div>

          {/* View All Button */}
          <div className="flex justify-center md:justify-end mt-8">
            <button
              className="flex items-center bg-[#068b07] text-white font-medium px-6 py-3 hover:bg-green-700 transition-all duration-300"
              onClick={() => navigate("/our-works")}
            >
              <span>View All Works</span>
              <MdArrowOutward className="ml-3 bg-[#121315] text-white p-1" size={32} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recent;
